import { QuillModules } from 'ngx-quill';

const colors = [
  '#000000',
  '#e60000',
  '#ff9900',
  '#ffff00',
  '#008a00',
  '#0066cc',
  '#9933ff',
  '#ffffff',
  '#facccc',
  '#ffebcc',
  '#ffffcc',
  '#cce8cc',
  '#cce0f5',
  '#ebd6ff',
  '#bbbbbb',
  '#f06666',
  '#ffc266',
  '#ffff66',
  '#66b966',
  '#66a3e0',
  '#c285ff',
  '#888888',
  '#a10000',
  '#b26b00',
  '#b2b200',
  '#006100',
  '#0047b2',
  '#6b24b2',
  '#444444',
  '#5c0000',
  '#663d00',
  '#666600',
  '#003700',
  '#002966',
  '#3d1466'
];

export const quillConfig: QuillModules = {
  toolbar: {
    container: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'color': colors }, { 'background': [] }, { 'align': [] }],
      ['link'],
    ],
  },
  history: {
    userOnly: true,
  },
};

// Every text format Quill 1.3.7 registers by default, minus the embeds (`image`,
// `video`, `formula`). Without a whitelist Quill turns pasted screenshots into
// base64 data URLs, which balloon the settings payload past the API body limit.
// Keeping all text formats means existing saved content keeps its formatting.
// Bind with `[formats]` on each <quill-editor>: QuillModule.forRoot() config is
// invisible to the root-provided QuillService when the module is lazy loaded.
export const quillFormats: string[] = [
  'background', 'bold', 'color', 'font', 'code', 'italic', 'link', 'size', 'strike',
  'script', 'underline',
  'blockquote', 'header', 'indent', 'list', 'align', 'direction', 'code-block',
];
